import * as React from 'react';
import {SearchToSelect} from "../../components";
import PropTypes from 'prop-types';
import accessStore from './AccessStore';

/** component that pages/searches one of Locations, Groups, or Accounts for selection */
export default function LocationGroupOfTypeSelector({
  type,
  ...props
}) {


  const getSearchResults = ({ query = '', offset = 0 }) => {
    const PAGE = 100;
    return accessStore.searchType(type, { q: query, offset, limit: PAGE })
      .then(items => {
        return {
          items, hasMore: items.length <= PAGE
        }
      });
  };

  const resolveSelection = (ids) => {
    return accessStore.resolveEntities(ids.map(x => `${type}-${x}`));
  };

  const getKey = (locationGroup) => locationGroup.entityId.id;

    return <SearchToSelect
      selectByKey
      eager
      renderOption={x => `${x.name} (${x.totalLocations})`}
      {...props}
      getSearchResults={getSearchResults}
      getKey={getKey}
      resolveSelection={resolveSelection}
    />

}

LocationGroupOfTypeSelector.propTypes = {
  ...SearchToSelect.propTypes,
  type: PropTypes.oneOf(["Location", "Group", "Account"]).isRequired
};
